<template>
    <div>
        <b-card class="mb-3 shadow" :title="$t('scdda_admin.sectors.header')">
            <b-button class="button-margin" variant="primary" @click.prevent="showNewItemForm" v-if="hasRole('Administrator')||hasRole('Berater')||hasRole('Erweiterter Einkäufer')"><b-icon icon="folder-plus" />{{ $t("scdda_admin.sectors.btn_new") }}</b-button>
            <b-button disabled class="button-margin" variant="outline-primary" @click.prevent="showImport" v-if="hasRole('Administrator')||hasRole('Berater')||hasRole('Erweiterter Einkäufer')"><b-icon icon="file-earmark-arrow-down" />{{ $t("scdda_admin.sectors.btn_import") }}</b-button>

            <br />
            <b-form-group horizontal :label="$t('scdda_admin.sectors.search')" class="mb-0">
                <b-input-group>
                    <b-input v-model="searchFilter" :placeholder="$t('scdda_admin.sectors.search_placeholder')" />
                    <b-input-group-append>
                        <b-button :disabled="!searchFilter" @click="searchFilter = ''">{{ $t("scdda_admin.sectors.search_clear") }}</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
            <br />
            <div class="table-scrollable">
            <b-table striped hover :items="sectors" :fields="fields" :filter="searchFilter">
                <template #cell(actions)="data">
                    <b-link class="m-1" href="#" @click="editItem(data.item)" v-if="hasRole('Administrator')||hasRole('Berater')||hasRole('Erweiterter Einkäufer')"><b-icon icon="pencil-square" scale="1.2"></b-icon></b-link>
                    <b-link class="m-1" href="#" @click="requestConfirmation(data.item)" v-if="hasRole('Administrator')||hasRole('Berater')||hasRole('Erweiterter Einkäufer')"><b-icon icon="trash" scale="1.2"></b-icon></b-link>
                </template>
            </b-table>
            </div>
            <br />
            <b-modal ref="confirmationModal" hide-footer :title="$t('scdda_admin.sectors.confirmation_header')">
                <div class="d-block text-center">
                    <p v-if="itemContext">{{ $t('scdda_admin.sectors.confirmation_message', {title: itemContext["sector_name_" + $i18n.locale]}) }}</p>
                </div>
                <b-button class="button-margin mt-3" variant="outline-danger" block @click="executeDelete"><b-icon icon="trash" />{{ $t("scdda_admin.sectors.confirmation_button") }}</b-button>
            </b-modal>
        </b-card>
        <Editsector ref="Editsector" :savedCallback="reload" />
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import Editsector from './Editsector';
    import SectorService from '../../../../../services/Riskmanagement/SectorService';

    export default {
        name: 'sectors',
        components: {Editsector},
        props: [],
        data() {
            return {
                searchFilter: null,
                itemContext: null,
            }
        },
        created() {
            this.fetchSectors();
        },
        methods: {
            ...mapActions({
                fetchSectors: 'sectors/fetch',
                deleteSectors: 'sectors/delete'
            }),
            showNewItemForm() {
                this.currentItemEditMode = false;
                this.$refs.Editsector.setItem({});
                this.$refs.Editsector.showModal();
            },
            editItem(item) {
                this.$refs.Editsector.setItem(item);
                this.$refs.Editsector.showModal();
                this.$refs.Editsector.enterEditMode();
            },
            requestConfirmation(item) {
                this.itemContext = item;
                this.$refs.confirmationModal.show();
            },
            executeDelete() {
                this.$refs.confirmationModal.hide();
                this.$store.commit('loading/setLoading', true);
                SectorService.delete(this.itemContext.id)
                    .then(response => {
                        this.$store.commit('loading/setLoading', false);
                        if(!response.data.success) {
                            this.$notify({
                                group: 'global',
                                title: this.$t('scdda_admin.sectors.error_title'),
                                type: 'error',
                                text: response.data.message
                            });
                        }

                        this.itemContext = null;
                        this.reload();
                    });
            },
            reload() {
                this.fetchSectors();
            },
        },
        computed: {
            ...mapGetters({
                hasRole: 'auth/hasRole',
                sectors: 'sectors/sectors'
            }),
            fields() {
                return [
                    { key: 'id',                label: 'Id'             , sortable: true  },
                    { key: 'sector_code_nace',  label: this.$t('scdda_admin.sectors.col_nace') , sortable: true  },
                    { key: 'sector_name_' + this.$i18n.locale,       label: this.$t('scdda_admin.sectors.col_name') , sortable: true  },
                    { key: 'actions',           label: this.$t('scdda_admin.sectors.col_actions') },
                ];
            },
        }
    }
</script>